import Axios from "axios";
import Vue from "vue";
import qs from "qs";
let http = Axios.create({
	headers: {
		"Content-Type": "application/json",
		// "clientKey": "csjk",
	},
	baseURL: window._GlobalConfig.api,
	timeout: 30000,
});
// 请求拦截器
http.interceptors.request.use(
	config => {
		let data = {};
		if (config.method == "post") {
			if (sessionStorage.getItem("userId") && !config.data.userId) {
				data.userId = sessionStorage.getItem("userId");
			}
			Object.assign(data, config.data);
			config.headers['Content-Type'] = "application/x-www-form-urlencoded";
			// config.headers['Content-Type'] = "multipart/form-data";
			config.data = qs.stringify(data);
		} else {
			if (sessionStorage.getItem("userId") && !config.params.userId) {
				data.userId = sessionStorage.getItem("userId");
			}
			Object.assign(config.params, data);
			config.headers['Content-Type'] = "application/json";
		}
		if (sessionStorage.getItem("token")) {
			config.headers.token = sessionStorage.getItem("token");
		}
		return config;
	},
	error => {
		return Promise.error(error);
	}
);
// 响应拦截器
http.interceptors.response.use(
	response => {
		if (response.status === 200) {
			return Promise.resolve(response.data);
		} else {
			return Promise.reject(response);
		}
	},
	error => {
		if (error && error.response) {
			if (error.response.status) {
				switch (error.response.status) {
					case 400:
						error.message = "错误请求";
						break;
					case 401:
						error.message = "未授权，请重新登录";
						break;
					case 403:
						error.message = "登录过期，请重新登录";
						sessionStorage.clear();
						break;
					case 404:
						error.message = "网络请求不存在";
						break;
					case 405:
						error.message = "请求方法错误";
						break;
					case 408:
						error.message = "请求超时";
						break;
					case 500:
						error.message = "服务器端出错";
						break;
					case 501:
						error.message = "网络未实现";
						break;
					case 502:
						error.message = "网络错误";
						break;
					case 503:
						error.message = "服务不可用";
						break;
					case 504:
						error.message = "网络超时";
						break;
					case 505:
						error.message = "http版本不支持该请求";
						break;
					default:
						error.message = `连接错误${error.response.status}`;
				}
			} else {
				error.message = "接口出现问题，无法请求";
			}
		}
		/* Toast({ //提示
			message: error.message,
			duration: 1500,
			forbidClick: true
		}); */
		return Promise.reject(error);
	}
);

const api = {
	get: (url, params = {}) => {
		return http.get(
			url, {
				params
			}, {
				cancelToken: new Axios.CancelToken(function executor(c) {
					Vue.$httpRequestList.push(c);
				})
			}
		);
	},
	post: (url, params = {}) => {
		return http.post(url, params, {
			cancelToken: new Axios.CancelToken(function executor(c) {
				Vue.$httpRequestList.push(c);
			})
		});
	}
};
export default api;
